import React from "react";
import styled from "styled-components";

import { Button as BootstrapButton } from "reactstrap";
import { RotateSpinLoader } from "react-css-loaders2";

const Button = ({ children, loading, ...props }) => {
  return (
    <StyledBootstrapButton disabled={loading || props.disabled} {...props}>
      {loading ? <StyledLoader color="#fff" size={2} /> : children}
    </StyledBootstrapButton>
  );
};

const StyledLoader = styled(RotateSpinLoader)`margin: 0;`;
const StyledBootstrapButton = styled(BootstrapButton)`
  display: flex;
  justify-content: center;
`;

const FullWidthButton = styled(Button)`
  border-radius: 2px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
`;

export { Button, FullWidthButton };



// WEBPACK FOOTER //
// ./src/components/Form/Button.js